<template>
  <Avatar :size="size">
    <AvatarFallback v-if="hasName(teamMember)" :color-key="getFullName(teamMember)">
      {{ fallback(getFullName(teamMember)) }}
    </AvatarFallback>
    <AvatarFallback v-else-if="teamMember.email" :color-key="teamMember.email">
      {{ fallback(teamMember.email) }}
    </AvatarFallback>
  </Avatar>
</template>

<script setup lang="ts">
import type { AvatarSize } from "~/components/shared/avatar/types";
import type { TeamMemberForAvatar } from "@asap/shared/utils/supabase.types";
import type { People } from "@asap/shared/utils/people";
import { getFullName, hasName } from "@asap/shared/utils/people";

const props = defineProps<{
  teamMember: Pick<TeamMemberForAvatar, "email"> & Pick<People, "first_name" | "last_name" | "auth_user">;
  size?: AvatarSize;
}>();

// Fixes the following issue: https://github.com/vuejs/language-tools/issues/3820
const { teamMember } = toRefs(props);

const fallback = (text: string) => text[0];
</script>
